import React from 'react';
import wb0 from '../img/Detail/athena-detail.jpg';
import './Detail.css';
const AthenaDetail = () => {
  return (
    <div className="image-detail-container">
      <img src={wb0} alt="Kuş" />
    </div>
    
  );
};

export default AthenaDetail;